export default __webpack_public_path__ + "static/media/nosotros.88a2c3cb.jpg";